export default __webpack_public_path__ + "static/media/reviewimg.f95493b1.png";